(() => {
  const BRAND_TEST = /\b(?:NATLEAN|Metabolize)\b/i;
  const BRAND_REPLACE = /\b(NATLEAN|Metabolize)\b(?:\s*[\u00ae\u2122])?/gi;
  const EXCLUDED_SELECTOR = [
    'script',
    'style',
    'noscript',
    'template',
    'textarea',
    'input',
    'select',
    'option',
    'code',
    'pre',
    'svg',
    'a[href^="mailto:"]',
    'a[href^="tel:"]',
    '[contenteditable="true"]',
    '[data-no-trademark]',
    '.natlean-trademarked',
    '.dagger-symbol'
  ].join(',');

  const shouldSkip = (node) => {
    const parent = node.parentElement;
    return !parent || parent.closest(EXCLUDED_SELECTOR);
  };

  const isSensitiveToken = (text, start, end) => {
    const tokenStart = text.slice(0, start).search(/[^\s()[\]{}<>"',;]*$/);
    const tokenEndMatch = text.slice(end).match(/^[^\s()[\]{}<>"',;]*/);
    const tokenEnd = end + (tokenEndMatch ? tokenEndMatch[0].length : 0);
    const token = text.slice(tokenStart, tokenEnd);

    return (
      token.includes('@') ||
      token.startsWith('#') ||
      /(?:https?:\/\/|www\.)/i.test(token) ||
      /(?:NATLEAN|Metabolize)\.[a-z]{2,}(?:[\/?#:]|$)/i.test(token) ||
      /[\\/](?:NATLEAN|Metabolize)(?:[\\/?#.]|$)/i.test(token) ||
      /(?:NATLEAN|Metabolize)(?:_[a-z0-9]|-[a-z]*\d)/i.test(token)
    );
  };

  const markTextNode = (node) => {
    if (shouldSkip(node) || !BRAND_TEST.test(node.data)) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    BRAND_REPLACE.lastIndex = 0;

    while ((match = BRAND_REPLACE.exec(node.data)) !== null) {
      let precedingText = node.data.slice(lastIndex, match.index);

      if (isSensitiveToken(node.data, match.index, BRAND_REPLACE.lastIndex)) {
        fragment.append(precedingText);
        fragment.append(match[0]);
        lastIndex = BRAND_REPLACE.lastIndex;
        continue;
      }

      const hasSpaceBefore = /[ \t]$/.test(precedingText);
      if (hasSpaceBefore) precedingText = precedingText.replace(/[ \t]+$/, '');
      fragment.append(precedingText);

      const brand = document.createElement('span');
      brand.className = 'natlean-trademarked';
      if (hasSpaceBefore) brand.classList.add('natlean-trademarked--space-before');
      brand.append(match[1]);

      const trademark = document.createElement('sup');
      trademark.className = 'natlean-trademark';
      trademark.setAttribute('aria-hidden', 'true');
      trademark.textContent = '\u2122';
      brand.append(trademark);

      const followingSpace = node.data.slice(BRAND_REPLACE.lastIndex).match(/^[ \t]+/);
      if (followingSpace) {
        brand.classList.add('natlean-trademarked--space-after');
        BRAND_REPLACE.lastIndex += followingSpace[0].length;
      }

      fragment.append(brand);

      lastIndex = BRAND_REPLACE.lastIndex;
    }

    if (lastIndex === 0) return;

    fragment.append(node.data.slice(lastIndex));
    node.replaceWith(fragment);
  };

  const markBrands = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      markTextNode(root);
      return;
    }

    if (!(root instanceof Element) || root.matches(EXCLUDED_SELECTOR)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(markTextNode);
  };

  const markDaggerTextNode = (node) => {
    if (shouldSkip(node) || !node.data.includes('\u2020')) return;

    const parts = node.data.split('\u2020');
    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      fragment.append(part);

      if (index < parts.length - 1) {
        const dagger = document.createElement('span');
        dagger.className = 'dagger-symbol';
        // dagger.textContent = '\u2020';
        dagger.textContent = '*';
        fragment.append(dagger);
      }
    });

    node.replaceWith(fragment);
  };

  const markDaggers = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      markDaggerTextNode(root);
      return;
    }

    if (!(root instanceof Element) || root.matches(EXCLUDED_SELECTOR)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(markDaggerTextNode);
  };

  const processContent = (root) => {
    markBrands(root);
    markDaggers(root);
  };

  const init = () => {
    processContent(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          markTextNode(mutation.target);
          markDaggerTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(processContent);
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
